import { render, staticRenderFns } from "./charts-form.vue?vue&type=template&id=dd59a574&"
import script from "./charts-form.vue?vue&type=script&lang=js&"
export * from "./charts-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports